function ShowVersionUI({ title, version }: { title?: string; version: string }) {
    return (
        <div style={{ position: 'fixed', right: 0, zIndex: 9999, padding: '12px', backgroundColor: '#00000099', color: '#ffffff' }}>
            {title} {version}
        </div>
    );
}

export default ShowVersionUI;
